import { ReactElement, ReactNode } from 'react'
import { Paper, Typography } from '@mui/material'

interface Props {
  label: string
  value: ReactNode
  caption?: ReactNode
  'data-cy'?: string
}

const StatTile = ({ label, value, caption, 'data-cy': dataCy }: Props): ReactElement => (
  <Paper variant="outlined" sx={{ p: 2, flex: 1, minWidth: 180 }} data-cy={dataCy}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="h5" sx={{ fontVariantNumeric: 'tabular-nums' }}>
      {value}
    </Typography>
    {caption && (
      <Typography variant="caption" color="text.secondary">
        {caption}
      </Typography>
    )}
  </Paper>
)

export default StatTile
